import { render, staticRenderFns } from "./OpenData.vue?vue&type=template&id=04576564&"
import script from "./OpenData.vue?vue&type=script&lang=js&"
export * from "./OpenData.vue?vue&type=script&lang=js&"
import style0 from "./OpenData.vue?vue&type=style&index=0&id=04576564&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports